export const PayCenterRoutes = [{
    path: '/PayCenter',
    component: () => import('./PayCenter.vue'),
    meta: {
        crumbName: '支付中心'
    },
    children: [
        {
            path: 'ReviewPayment',
            name: '测评支付',
            component: () => import('../ReviewPayment.vue'),
            meta: {
                //标明是否需要登录后才能访问
                auth:true
            }
        }, {
            path: 'Alipay',
            name: '支付宝支付',
            component: () => import('../Alipay.vue'),
            meta: {
                //标明是否需要登录后才能访问
                auth:true
            }
        }, {
            path: 'PaymentAgree',
            name: '网站支付协议',
            component: () => import('../PaymentAgree.vue'),
            meta: {
                //标明是否需要登录后才能访问
                auth:true
            }
        }
    ]
}]



// WEBPACK FOOTER //
// ./src/pages/PayCenter/router/PayCenter.routes.js